// removed by extract-text-webpack-plugin
module.exports = {"Logo":"Logo__Logo__2A07e"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Logo/Logo.css
// module id = 70
// module chunks = 3